import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ConfirmationService, LazyLoadEvent, MessageService, PrimeNGConfig} from 'primeng/api';
import {Constant} from '../util/constant';
import {SharedService} from '../web-services/shared.service';
import {ConstantService} from '../web-services/constant.service';
import {Labels} from '../util/labels';
import {AgencyExpertService} from '../web-services/agency-expert.service';
import {AgencyService} from '../web-services/agency.service';
import {UsersService} from '../web-services/users.service';

declare var closeAddOverlaydiv: Function;
declare var closeSearchOverlaydiv: Function;
declare var openAddOverlaydiv: Function;

@Component({selector: 'app-agency-expert', templateUrl: './agency-expert.component.html', styleUrls: ['./agency-expert.component.css']})
export class AgencyExpertComponent implements OnInit {
    public labels = Labels;
    formButton: string = this.translate(this.labels.btnAdd);
    submitted = false;
    selectedIndex = -1;
    updateAgencyExpertId = null;
    agencyList: any = [];
    usersList: any = [];
    agencyExpertList: any = [];
    agencyExpertSearch: FormGroup;
    clearSearchBtn = false;
    totalRecords;
    itemPerPage: number = Constant.ITEM_PER_PAGE;
    agencyExpertForm: FormGroup;
    constantList = [];
    pageNo: number = 0;
    onValueChange = true;

    showSearchDialog = false;
    showSearchBtn = false;
    showAddDialog = false;
    showAddBtn = false;
    editTag = false;
    disableColumn = false;
    passwordType = 'password';

    addEditTitle = '';
    constructor(
        private agencyExpertServices: AgencyExpertService, private agencyServices: AgencyService, private usersServices: UsersService,
        private primengConfig: PrimeNGConfig, private confirmation: ConfirmationService, private messageService: MessageService,
        private route: Router, private loader: NgxUiLoaderService, private constantService: ConstantService,
        private sharedService: SharedService
    ) {
    };

    get addUpdateTitle() {
        return this.updateAgencyExpertId == null ? this.translate(this.labels.btnAdd) : this.translate(this.labels.btnUpdate);
    }

    onClearSearch() {
        this.agencyExpertSearch.reset();
        this.selectedIndex = -1;
    }

    onSearch() {
        this.clearSearchBtn = true;
        this.countAgencyExpert();
        this.findAllAgencyExpert();
        closeSearchOverlaydiv();
    }

    startLoader() {
        this.loader.start();
        setTimeout(() => {
            this.loader.stop();
        }, 3000);
    }

    stopLoader() {
        this.loader.stop();
    }

    countAgencyExpert() {
        this.agencyExpertServices.countAgencyExpert(this.agencyExpertSearch.value).subscribe(res => {
            if (res['message'] == 'Success') {
                this.totalRecords = res['data'][0];
                this.findAllAgencyExpert();
            } else {
                this.totalRecords = 0;
            }
        }, err => {
            console.error('err: ', err);
        });
    }

    onSubmit() {
        this.addUpdateAgencyExpert(this.agencyExpertForm.value);
        this.submitted = false;
        this.onClearAdd();
    }

    onPageChnage(event: LazyLoadEvent) {
        this.itemPerPage = event.rows;
        this.pageNo = event.first / event.rows;
        this.findAllAgencyExpert();
    }

    clearSearchResult() {
        this.clearSearchBtn = false;
        this.agencyExpertSearch.reset();
        this.countAgencyExpert();
        // this.findAllAgencyExpert();
    }

    addUpdateAgencyExpert(agencyExpert) {
        this.startLoader();
        if (this.updateAgencyExpertId == null) {
            this.agencyExpertServices.addAgencyExpert(this.agencyExpertForm.value).subscribe(res => {
                if (res['message'] == 'Success') {
                    agencyExpert = res['data'][0];
                    this.agencyExpertList.push(agencyExpert);
                    this.messageService.add(
                        {
                            severity: 'success',
                            summary: this.translate(this.labels.btnAdd),
                            detail: this.translate(this.labels.entityNameAgencyExpert)
                        });
                    this.submitted = true;
                    this.showHideAddDialog();
                    this.countAgencyExpert();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
        } else {
            agencyExpert.agencyExpertId = this.updateAgencyExpertId;
            this.agencyExpertServices.updateAgencyExpert(agencyExpert).subscribe(res => {
                if (res['message'] == 'Success') {
                    this.agencyExpertList[this.selectedIndex] = res['data'][0];
                    this.submitted = true;
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.btnUpdate),
                                                detail: this.translate(this.labels.entityNameAgencyExpert)
                                            });
                    this.showSearchBtn = false;
                    this.showAddBtn = false;
                    this.showSearchDialog = false;
                    this.showAddDialog = false;
                    this.editTag = false;
                    this.countAgencyExpert();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
            this.updateAgencyExpertId = null;
            this.onClearAdd();
            this.formButton = this.translate(this.labels.btnAdd);
        }
    }

    translate(label) {
        return this.sharedService.verifyLabel(label, this.constantList);
    }

    getConstantList(formId) {
        this.constantService.getFormConstantsList(formId).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.constantList = data['data'];
            } else {
                this.constantList = [];
            }
        });
    }

    ngOnInit() {
        this.addEditTitle = this.labels.btnAdd;
        this.findAllAgency();
        this.findAllUsers();
        this.agencyExpertForm = new FormGroup(
            {
                agencyId: new FormControl(),
                expertId: new FormControl(0, [Validators.required, Validators.min(0)]),
                userId: new FormControl(),
            });
        this.agencyExpertSearch = new FormGroup({agencyId: new FormControl(), expertId: new FormControl(), userId: new FormControl(),});
        this.countAgencyExpert();
        this.findAllAgencyExpert();
        this.getConstantList(1234);
        this.primengConfig.ripple = true;
        this.clearSearchBtn = false;
        this.agencyExpertSearch.valueChanges.subscribe(data => {
            this.onValueChange = false;
        });
    }

    findAllAgencyExpert() {
        this.startLoader();
        this.agencyExpertServices.findAllAgencyExpert(this.agencyExpertSearch.value, this.pageNo, this.itemPerPage).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    this.agencyExpertList = res['data'];
                } else {
                    this.agencyExpertList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    deleteByIdAgencyExpert(agencyExpertId: number, index) {
        this.confirmation.confirm({
                                      message: this.translate(this.labels.DELETE_MSG), accept: () => {
                this.startLoader();
                this.agencyExpertServices.deleteByIdAgencyExpert(agencyExpertId).subscribe(res => {
                    if (res['message'] == 'Success') {
                        this.agencyExpertList.splice(index, 1);
                        this.messageService.add({
                                                    severity: 'warn',
                                                    summary: this.translate(this.labels.btnDelete),
                                                    detail: this.translate(this.labels.entityNameAgencyExpert)
                                                });
                        this.countAgencyExpert();
                    } else {
                        console.error('error: ', res['documentation']);
                        this.startLoader();
                    }
                }, err => {
                    console.error('err: ', err);
                    this.stopLoader();
                });
            }
                                  });
    }

    loadAgencyExpertToEdit(agencyExpertId: number, index) {
        let agencyExpert = this.agencyExpertList.find(x => x['agencyExpertId'] == agencyExpertId);
        this.submitted = null;
        this.formButton = this.translate(this.labels.btnEdit);
        this.updateAgencyExpertId = agencyExpert['agencyExpertId'];
        this.selectedIndex = index;
        this.agencyExpertForm.controls['agencyId'].setValue(agencyExpert['agencyId']['agencyId']);
        this.agencyExpertForm.controls['expertId'].setValue(agencyExpert['expertId']);
        this.agencyExpertForm.controls['userId'].setValue(agencyExpert['userId']['userId']);
        openAddOverlaydiv();
    }

    onClearAdd() {
        this.agencyExpertForm.reset();
        this.agencyExpertForm.markAsUntouched();
        this.updateAgencyExpertId = null;
        closeAddOverlaydiv();
    }

    findAllAgency() {
        let temp = [];
        this.startLoader();
        this.agencyServices.findAllAgency(null, null, null).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    temp = res['data'];
                    for (let object of temp) {
                        let dropDown = {label: '', value: ''};
                        dropDown.value = object['agencyId'];
                        dropDown.label = object['agencyTitle'];
                        this.agencyList.push(dropDown);
                    }
                } else {
                    this.agencyList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    findAllUsers() {
        let temp = [];
        this.startLoader();
        this.usersServices.findAllUsers(null, null, null).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    temp = res['data'];
                    for (let object of temp) {
                        let dropDown = {label: '', value: ''};
                        dropDown.value = object['userId'];
                        dropDown.label = object['userName'];
                        this.usersList.push(dropDown);
                    }
                } else {
                    this.usersList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    fieldReset(control) {
        return this.agencyExpertForm.get(control).reset();
    }

    diplayeIconInField(control) {
        return this.agencyExpertForm.get(control)?.valid;
    }

    inputFieldDanger(control) {
        return !this.agencyExpertForm.get(control)?.valid && this.agencyExpertForm?.get(control)?.touched;
    }

    onCloseAdd() {
        closeAddOverlaydiv();
        this.agencyExpertForm.reset();
    }

    onCloseSearch() {
        closeSearchOverlaydiv();
        this.agencyExpertSearch.reset();
    }

    refresh() {
        this.countAgencyExpert();
    }

    onAddOverlayDiv() {
        openAddOverlaydiv();
        this.agencyExpertForm.reset();
    }
    // by ali
    showHideSearchDialog() {
        this.showSearchDialog = !this.showSearchDialog;
        this.showSearchBtn = this.showSearchDialog;
        this.showAddBtn = this.showSearchDialog;
    }

    showHideAddDialog() {
        if(!this.showAddDialog) {
            this.agencyExpertForm.reset();
        }
        this.addEditTitle = this.labels.btnAdd;
        this.showAddDialog = !this.showAddDialog;
        this.showAddBtn = this.showAddDialog;
        this.showSearchBtn = this.showAddDialog;
        this.editTag = false;
        this.updateAgencyExpertId = null;
    }
}
